import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { CompProps } from '../../Editor'
import { TaxIDInput } from '../commonQuestions/TaxID'

const businessTaxID: FC<CompProps> = (props) => {
  return <TaxIDInput {...props} testID="businessInfo_ein" />
}

export default {
  title: 'Business.TaxId',
  component: observer(businessTaxID),
}
